<template>
    <b-badge :variant="variant">
        {{ $t('Component(Text):status-' + status) }}
    </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
export default {
    components: {
        BBadge
    },
    props: {
        type: {
            type: String,
        },
        status: {
            type: String
        }
    },
    computed: {
        variant() {
            if (!this.$store.state.request[this.type]) {
                return 'secondary';
            }
            if (this.$store.state.request[this.type].badgeVariant[this.status] === undefined) {
                return 'secondary';
            }

            return this.$store.state.request[this.type].badgeVariant[this.status];
        }
    }
}
</script>
